exports.API_ROOT = 'https://api.bethel.io'
exports.DASHBOARD_ROOT = 'http://my.bethel.io'
